import { Component } from '@angular/core';
import { FormGroup, FormControl, FormArray } from '@angular/forms';
import { ModalBaseComponent, StravaActivityLogViewModel, StravaService, TranslatedToastrService, ValidationHandlerService } from 'lib/Vestra.shared';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-strava-activity-view',
    templateUrl: './strava-activity-view.component.html',
    styleUrls: ['./strava-activity-view.component.scss'],
})
export class StravaActivityViewComponent extends ModalBaseComponent {
    constructor(
        private bsModalRef: BsModalRef,
        private stravaService: StravaService,
        protected override validationHandlerService: ValidationHandlerService,
        protected override modalService: BsModalService,
        private translatedToastrService: TranslatedToastrService,
        protected override spinnerService: NgxSpinnerService,
        protected translateService: TranslateService,
    ) {
        super(spinnerService, modalService, validationHandlerService);
    }
    public title: string;
    public item: number;

    public webhookRawContent: any;
    public webhookRawContentText: string;

    public activityRawContent: any;
    public activityRawContentText: string;

    get hasWebhookRawContent(): boolean {
        return !!this.webhookRawContent; 
    }
    get hasActivityRawContent(): boolean {
        return !!this.activityRawContent; 
    }

    private getFormGroup(): FormGroup {
        return new FormGroup({
            id: new FormControl({ value: '', disabled: true }),
            stravaUserId: new FormControl({ value: '', disabled: true }),
            stravaUsername: new FormControl({ value: '', disabled: true }),
            activityId: new FormControl({ value: 0, disabled: true }),
            calculatedCredit: new FormControl({ value: 0, disabled: true }),
            status: new FormControl({ value: '', disabled: true }),
            error: new FormControl({ value: '', disabled: true }),
            webhookRawContent: new FormControl({ value: '', disabled: true }),
            activityRawContent: new FormControl({ value: '', disabled: true }),
            modified: new FormControl({ value: '', disabled: true }),
        });
    }
    public form: FormGroup = this.getFormGroup();

    public async init() {
        this.handleSpinner(
            firstValueFrom(this.stravaService.getStravaActivityLog(this.item))
                .then(res => {
                    if (res.result.error)
                    {
                        const originalError = res.result.error;
                        const normalizedError = originalError
                            .split("\\n").join("\n")   
                            .split("\r\n").join("\n")  
                            .split("\r").join("\n");   

                        const errorLines = normalizedError
                            .split("\n")
                            .map(line => line.trim())
                            .filter(line => line.length > 0);

                        if (errorLines.length > 0) {
                            const translationKey = errorLines[0];
                            const translatedMessage = this.translateService.instant(translationKey);
                            let newError = translatedMessage ? translatedMessage : translationKey;

                            const additionalLines = errorLines.slice(1);
                            if (additionalLines.length > 0) {
                                newError += "\n" + additionalLines.join("\n");
                            }

                            if (newError !== originalError.trim()) {
                                newError += "\n\n\n" + originalError;
                            }

                            res.result.error = newError;
                        }
                    }
                    this.form = this.getFormGroup();
                    res.result.modified = new Date(res.result.modified);
                    this.form.patchValue(res.result);
                    this.loadJson(res.result.activityRawContent, "activity")
                    this.loadJson(res.result.webhookRawContent, "webhook")
                    return Promise.resolve(res);
                })
                .catch((err: HttpErrorResponse) => {
                    this.validationHandlerService.handleServerError(err, this.form);
                })
        );
    }
    
    private loadJson(jsonString: string, type: string) {
        if (!jsonString) return;
        let content = jsonString.replace(/^"|"$/g, '').replace(/\\"/g, '"');

        try {
            const parsed = JSON.parse(content);
            if (type === "activity") {
                this.activityRawContent = parsed;
                this.activityRawContentText = null;
            } else if (type === "webhook") {
                this.webhookRawContent = parsed;
                this.webhookRawContentText = null;
            }
        } catch {
            if (type === "activity") {
                this.activityRawContent = null;
                this.activityRawContentText = content;
            } else if (type === "webhook") {
                this.webhookRawContent = null;
                this.webhookRawContentText = content;
            }
        }
    }
    public ngAfterViewInit() {
        this.init();
    }
}
